/**
 * PB-FND-75 — Choice / Button field plugin (registry adapter).
 * Extracted from pb-field-runtime; wired via createChoiceAdapter(deps).
 */

/** Choice adapter post-mount — "other" input wiring (migrated from applyInputSettings). */
function initChoiceStepFromRegistry(stepEl, ctx, deps) {
  if (!stepEl) return;
  const { resolveSelections } = deps;
  const grid = stepEl.querySelector('.btn-grid');
  if (!grid || (grid.classList.contains('pb-topic-multi') && grid.dataset.topicList)) return;

  const pb = (ctx && ctx.pb) || (typeof window !== 'undefined' ? window.productBuilder : null);
  const selections = resolveSelections(ctx);
  const otherBtn = grid.querySelector('.meta-btn[data-other="true"]');

  if (otherBtn) {
    const label = otherBtn.dataset.label;
    const currentVal = String(selections[label] || '');
    const selectedValues = currentVal
      .split(',')
      .map(function (v) {
        return v.trim();
      })
      .filter(Boolean);
    const values = Array.from(grid.querySelectorAll('.meta-btn')).map(function (b) {
      return b.dataset.value;
    });
    const knownSelected = selectedValues.filter(function (v) {
      return values.indexOf(v) !== -1;
    });
    const unknownSelected = selectedValues.filter(function (v) {
      return values.indexOf(v) === -1;
    });

    grid.querySelectorAll('.meta-btn').forEach(function (b) {
      if (b.dataset.other === 'true') return;
      b.classList.toggle('active', knownSelected.indexOf(b.dataset.value) !== -1);
    });

    const isOtherWithCustom = unknownSelected.length > 0;
    if (isOtherWithCustom) {
      otherBtn.classList.add('active');
      let wrap = null;
      stepEl.querySelectorAll('.pb-other-input-wrap').forEach(function (w) {
        if (w.dataset.label === label) wrap = w;
      });
      if (wrap) {
        wrap.style.display = '';
        const input = wrap.querySelector('input.pb-other-input');
        if (input) input.value = unknownSelected.join(', ');
      }
    } else {
      otherBtn.classList.remove('active');
    }
  }

  if (pb && typeof pb.validateButtonGrid === 'function') {
    pb.validateButtonGrid(grid);
  }
}

/**
 * @param {object} deps — shared field-runtime helpers
 */
export function createChoiceAdapter(deps) {
  const {
    resolveEsc,
    resolveSelections,
    settingsToString,
    extractChoices,
    resolveToken,
    renderControlShell,
    renderImageColumn,
    resolveRuntimeParseSettings,
    validateChoiceGrid,
  } = deps;

  return {
    id: 'choice',
    matches(field) {
      const t = String((field && field.type) || '');
      return t.includes('Choice') || t.includes('Button');
    },
    renderStep(ctx) {
      const field = ctx.field;
      const esc = resolveEsc(ctx);
      const settingsRaw = field.settings;
      const settingsStr = settingsToString(settingsRaw);
      const choices = extractChoices(settingsRaw, settingsStr);
      const hasOtherChoice = choices.some(function (c) {
        return String(c).trim().toLowerCase() === 'other';
      });
      const selections = resolveSelections(ctx);
      let btns = '';
      choices.forEach(function (choice) {
        const choiceLabel = choice;
        const isOther = String(choiceLabel).trim().toLowerCase() === 'other';
        const resolvedLabel = resolveToken(ctx, choiceLabel);
        const isActive = selections[field.label] === resolvedLabel;
        btns +=
          '<button type="button" class="builder-btn meta-btn' +
          (isActive ? ' active' : '') +
          '" data-label="' +
          esc(field.label) +
          '" data-value="' +
          esc(resolvedLabel) +
          '" data-pb-template="' +
          esc(choiceLabel) +
          '" data-pb-value-target="self"' +
          (isOther ? ' data-other="true"' : '') +
          ' onclick="window.productBuilder.selectMeta(this)">' +
          esc(resolvedLabel) +
          '</button>';
      });
      let inputHtml =
        '<div class="btn-grid" data-settings="' + esc(settingsStr) + '">' + btns + '</div>';
      if (hasOtherChoice) {
        inputHtml +=
          '<div class="pb-other-input-wrap" data-label="' +
          esc(field.label) +
          '" style="display:none; margin-top:8px;">' +
          '<input type="text" class="builder-input pb-other-input" data-label="' +
          esc(field.label) +
          '" placeholder="Please specify..." data-other-for="' +
          esc(field.label) +
          '">' +
          '</div>';
      }
      const visRaw = String(field.visual || '').trim();
      return {
        controlHtml: renderControlShell(field, inputHtml, ctx, { useQuestionHighlight: !visRaw }),
        imageHtml: renderImageColumn(field, ctx),
        stepAttrs: '',
        extraClasses: !visRaw ? 'pb-step-hide-question' : '',
      };
    },
    initStep(stepEl, ctx) {
      initChoiceStepFromRegistry(stepEl, ctx, deps);
    },
    validateStep(stepEl, ctx) {
      const grid = stepEl && stepEl.querySelector('.btn-grid');
      if (!grid) return true;
      const parseFn = resolveRuntimeParseSettings(ctx);
      const settingsStr =
        grid.dataset.settings ||
        (ctx && ctx.field && ctx.field.settings != null ? settingsToString(ctx.field.settings) : '');
      return validateChoiceGrid(grid, parseFn(settingsStr));
    },
    hydrateStep(stepEl, ctx) {
      this.initStep(stepEl, ctx);
    },
    flushStep(stepEl, ctx) {
      const field = ctx.field;
      const active = stepEl && stepEl.querySelector('.builder-btn.meta-btn.active');
      if (!active || !ctx.selections) return;
      ctx.selections[field.label] = active.getAttribute('data-value') || '';
    },
  };
}
